import service from '@/services/currency'
const namespaced = true
const state = {
  currencyList: []
}
const getters = {
  getCurrencyList: state => state.currencyList
}
const actions = {
  async loadCurrencyList({ commit }) {
    if (Array.isArray(state.currencyList) && state.currencyList.length > 0) {
      return
    }
    const response = await service.getCurrencies()
    if (response?.data?.error?.type === 200) {
      commit('setCurrencyList', response.data.data)
    }
  }
}
const mutations = {
  setCurrencyList(state, payload) {
    state.currencyList = payload
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
